import React, {Component} from 'react';
import {observer} from "mobx-react";

class Bool extends Component {
  render() {
    if(this.props.value == '1') {
      return (
        <span>Да</span>
      )
    } else {
      return (
        <span className="op50">Нет</span>
      )
    }
  }
}

export default observer(Bool);